import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <polygon points="3 11 22 2 13 21 11 13 3 11"/>
</svg>`;

const Navigation = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='navigation' svg={svg} {...props} />
  )
);

Navigation.displayName = 'NavigationIcon';

export default Navigation;
